import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import BudgetSubproject from '../../../../widgets/budget/BudgetSubproject'
import { getSchemaSubPaymentSave } from '../../../../redux/actions/paymentSave'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ProjectBasicInfoSubProject from '../../../../widgets/projectBasicInfo/ProjectBasicInfoSubProject'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'

export default function PaymentSaveSub() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaSubPaymentSave(projectId)
      console.log('res ', _schema)
      setSchema(_schema)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isSubProject>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ProjectBasicInfoSubProject schema={schema.forms.projectInfo} />
      <br />
      <BudgetSubproject
        schema={schema.forms}
        isEditable={!schema.forms.budget.disabled}
        isEditableBudgetPlan={false}
      />
      <br />
    </SidebarProposal>
  )
}
